interface ConfluenceIconProps {
  width?: string;
  height?: string;
}

const ConfluenceIcon: React.FC<ConfluenceIconProps> = ({ width = "24px", height = "24px" }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_17383_52297)">
<path d="M1.00081 19.2478C0.715378 19.668 0.394811 20.1556 0.122548 20.5441C-0.121148 20.9158 0.00967778 21.3953 0.416767 21.6223L6.1255 24.7937C6.32588 24.9054 6.56757 24.9397 6.79628 24.889C7.025 24.8384 7.22158 24.7069 7.34189 24.5241C7.57024 24.1792 7.86446 23.7313 8.18503 23.2516C10.4466 19.882 12.7213 20.2943 16.8228 22.0623L22.4832 24.4924C22.6976 24.5845 22.9441 24.5943 23.1667 24.5197C23.3892 24.445 23.5688 24.2921 23.6645 24.096L26.3827 18.5461C26.5747 18.1497 26.3793 17.6875 25.9436 17.5075C24.7491 17.0001 22.3734 15.9892 20.2348 15.0576C12.5412 11.6841 6.00254 11.9021 1.00081 19.2478Z" fill="url(#paint0_linear_17383_52297)"/>
<path d="M26.5983 6.65284C26.8837 6.23264 27.2043 5.74504 27.4765 5.35655C27.7202 4.98479 27.5894 4.50534 27.1823 4.27829L21.4736 1.10693C21.2716 0.984098 21.0221 0.942517 20.7848 0.992124C20.5475 1.04173 20.3437 1.17807 20.222 1.36857C19.9937 1.71345 19.6995 2.16141 19.3789 2.64108C17.1174 6.01065 14.8427 5.59837 10.7412 3.83034L5.09831 1.41217C4.88393 1.32006 4.63737 1.31023 4.41482 1.38491C4.19228 1.45959 4.01271 1.61243 3.91704 1.80859L1.19881 7.35847C1.00676 7.75485 1.20217 8.21703 1.63794 8.39709C2.83238 8.90451 5.20809 9.91538 7.34667 10.847C15.0578 14.2165 21.5965 13.9906 26.5983 6.65284Z" fill="url(#paint1_linear_17383_52297)"/>
</g>
<defs>
<linearGradient id="paint0_linear_17383_52297" x1="2622.9" y1="1360.15" x2="2086.06" y2="-4.12604" gradientUnits="userSpaceOnUse">
<stop offset="0.18" stop-color="#0052CC"/>
<stop offset="1" stop-color="#2684FF"/>
</linearGradient>
<linearGradient id="paint1_linear_17383_52297" x1="25.6318" y1="-149.621" x2="563.353" y2="1215.39" gradientUnits="userSpaceOnUse">
<stop offset="0.18" stop-color="#0052CC"/>
<stop offset="1" stop-color="#2684FF"/>
</linearGradient>
<clipPath id="clip0_17383_52297">
<rect width="27.6667" height="24" fill="white" transform="translate(0 0.97168)"/>
</clipPath>
</defs>
</svg>
    )
}
export default ConfluenceIcon